import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'

import {ClientTable} from 'vue-tables-2'

import store from './store';
import i18n from './i18n'
import VueCryptojs from 'vue-cryptojs'
import VueQuillEditor from 'vue-quill-editor'
 
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import YourConsts from './plugins/constPlugin'

Vue.use(YourConsts)

 
Vue.use(VueQuillEditor, /* { default global options } */)

 
Vue.use(VueCryptojs)
Vue.use(ElementUI, {locale});
Vue.config.productionTip = false
Vue.use(ClientTable)

window.i18next = i18n

new Vue({
    render: h => h(App),
    mode: 'history',
    store,
    router,
    i18n,

    beforeCreate: function () {
        if (this.$route.path === '/' && localStorage.getItem('accuraAuthToken') === null && this.$route.name === 'source-confirmation' && this.$route.name === 'pocket-confirmation' && this.$route.name === 'facebook-confirmation' && this.$route.name === 'twitter-confirmation' && this.$route.name === 'claim-request-confirmation' && this.$route.name === 'embeddable-list' && this.$route.name === 'embeddable-article') {
            router.push('/sign-in')
        }
    }
}).$mount('#app')
